/** Business audience marker plus existing first-touch signup attribution. */
export const businessOnboardingHref =
	'/onboarding?business=true&utm_source=kody.codes&utm_medium=business-page&utm_campaign=business'
